(function () {
	'use strict';

	angular.module('sempraWebapp').service('karcherOpenCloseHours', karcherOpenCloseHoursService);

	/** @ngInject */
	function karcherOpenCloseHoursService () {
		this.lightsOn = function(data) {
      var hours = {};
      for (var key in data) {
        if (key.includes('LIGHT_START')) {
          hours[key] = data[key];
        }
      }
      return Object.values(hours);
    };
    this.lightsOff = function(data) {
      var hours = {};
      for (var key in data) {
        if (key.includes('LIGHT_STOP')) {
          hours[key] = data[key];
        }
      }
      return Object.values(hours);
    };
    this.washBoxOn = function(data) {
      var hours = {};
      for (var key in data) {
        if (key.includes('OPERATING_TIME_START')) {
          hours[key] = data[key];
        }
      }
      return Object.values(hours);
    };
    this.washBoxOff = function(data) {
      var hours = {};
      for (var key in data) {
        if (key.includes('OPERATING_TIME_STOP')) {
          hours[key] = data[key];
        }
      }
      return Object.values(hours);
    };
    this.vacuumOn = function(data) {
      var hours = {};
      for (var key in data) {
        if (key.includes('OPERATING_TIME_VACUUM_START')) {
          hours[key] = data[key];
        }
      }
      return Object.values(hours);
    };
    this.vacuumOff = function(data) {
      var hours = {};
      for (var key in data) {
        if (key.includes('OPERATING_TIME_VACUUM_STOP')) {
          hours[key] = data[key];
        }
      }
      return Object.values(hours);
    };

	}
  })();
